export const ROLES = ["admin", "editor", "contributor"] as const;
export type Role = (typeof ROLES)[number];

/** Permission checks shared by Manos Studio (to show controls) and the API (to enforce them). */
export const can = {
  publish: (role: Role) => role === "admin" || role === "editor",
  editLayout: (role: Role) => role === "admin" || role === "editor",
  manageCategories: (role: Role) => role === "admin" || role === "editor",
  manageTeam: (role: Role) => role === "admin",
  editWork: (role: Role, isOwner: boolean) => role !== "contributor" || isOwner,
};
